import { CollectionsFilter, ReportFilter } from '../../types';

export const getAccountingInformationReportPdfFilters = (
  reportFilters: ReportFilter,
  collectionsFilters: CollectionsFilter
): ReportFilter => ({
  ...reportFilters,
  startBusinessDate: collectionsFilters.startBusinessDate,
  endBusinessDate: collectionsFilters.endBusinessDate,
  groupBy: collectionsFilters.groupBy,
});
